import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { PeriodosContratoService } from '@services/periodos-contrato/periodos-contrato.service';
import { TipoAjusteContratoService } from '@services/tipo-ajuste-contrato/tipoAjusteContrato.service';
import { PeriodoContratoFilter } from '@models/periodos-contrato/periodoContratoFilter.model';
import { PeriodoContratoDetailDto } from '@models/periodos-contrato/periodoContratoDetailDto.model';
import { PersonaPropietarioDto } from '@models/propietarios/personaPropietarioDto.model';
import { TipoAjusteContratoDto } from '@models/tipo-ajuste-contrato/tipoAjusteContratoDto.model';
import { BaseDto } from '@models/base/baseDto.model';
import { DatePipe } from '@angular/common';
import { isFalsy } from 'utility-types';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DATE_FORMATS } from '../periodos-contrato/periodo-contrato.component';
import { EstadosContratoService } from '@services/estados-contratos/estados-contrato.service';


interface GrupoPropiedad {
  idContrato: number;
  descripcionContrato: string;
  numeroContrato: number | null;
  direccionPropiedad: string;
  inquilino: string;
  fechaVencimientoContrato: any;
  periodos: PeriodoDetalleFila[];
  totalBruto: number;
  totalNeto: number;
  sortField: string;
  sortDirection: 'asc' | 'desc';
}

interface PeriodoDetalleFila {
  periodoMes: number;
  periodoAnio: number;
  periodo: string;
  importeAlquiler: number;
  importeNetoEstimado: number;
  fechaVencimiento: any;
  fechaPago: any;
  fechaLiquidacion: any;
}

@Component({
  selector: 'app-reporte-propietario-mensual',
  templateUrl: './reporte-propietario-mensual.component.html',
  styleUrls: ['./reporte-propietario-mensual.component.css'],
  providers: [DatePipe,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS.default },
  ],
})
export class ReportePropietarioMensualComponent implements OnInit {

  form: FormGroup;
  formBuilder = new FormBuilder;
  get f() { return this.form.controls; }

  lstTiposAjusteContrato!: TipoAjusteContratoDto[];
  lstEstadosContrato: BaseDto[] = [];
  propietarioSeleccionado: PersonaPropietarioDto | null = null;
  checkedFiltroAvanzado: boolean = false;
  grupos: GrupoPropiedad[] = [];
  totalGeneralBruto = 0;
  totalGeneralNeto = 0;
  data = false;

  constructor(
    private periodosContratoService: PeriodosContratoService,
    private tipoAjusteContratoService: TipoAjusteContratoService,
    private estadosContratoService: EstadosContratoService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private datepipe: DatePipe,
  ) {
    this.form = this.formBuilder.group({
      TiposAjusteContrato: [[], Validators.compose([Validators.required])],
      EstadosContrato: [[]],
      FechaAjusteDesde: [],
      FechaAjusteHasta: [],
      FechaVencimientoDesde: [],
      FechaVencimientoHasta: [],
      FechaLiquidacionDesde: [],
      FechaLiquidacionHasta: [],
      FechaPagoDesde: [],
      FechaPagoHasta: [],
      PeriodoMesDesde: [],
      PeriodoAnioDesde: [],
      PeriodoMesHasta: [],
      PeriodoAnioHasta: [],
      EsContratoActivo: [null],
    });
  }

  ngOnInit(): void {
    this.getAllTipoAjusteContrato();
    this.getAllEstadosContrato();
  }

  filtrosAvanzados(event: any) {
    this.checkedFiltroAvanzado = event.checked;
  }
  getAllTipoAjusteContrato() {
    this.spinner.show("spBusquedaTipoAjusteContrato");
    this.tipoAjusteContratoService.getAll().subscribe(
      data => {
        this.spinner.hide("spBusquedaTipoAjusteContrato");
        this.lstTiposAjusteContrato = data.sort((a, b) => a.descripcion.toString().localeCompare(b.descripcion.toString()));
        const idsSeleccionados = this.lstTiposAjusteContrato.map(tipo => tipo.id);
        this.form.get('TiposAjusteContrato')?.setValue(idsSeleccionados);
      },
      error => {
        this.spinner.hide("spBusquedaTipoAjusteContrato");
        this.snackBar.showError(error, "Error");
      }
    );
  }

  getAllEstadosContrato() {
    this.spinner.show("spBusquedaEstadosContrato");
    this.estadosContratoService.getAll().subscribe(
      data => {
        this.spinner.hide("spBusquedaEstadosContrato");
        this.lstEstadosContrato = data.sort((a, b) => a.descripcion.toString().localeCompare(b.descripcion.toString()));
      },
      error => {
        this.spinner.hide("spBusquedaEstadosContrato");
        this.snackBar.showError(error, "Error");
      }
    );
  }

  selectPropietario(propietario: PersonaPropietarioDto | null) {
    this.propietarioSeleccionado = propietario;
  }

  private formatearFecha(desde: any, hasta: any): { desde: string, hasta: string } {
    let fDesde = this.datepipe.transform(desde, 'yyyy-MM-dd') as string;
    let fHasta = this.datepipe.transform(hasta, 'yyyy-MM-dd') as string;
    if (fDesde) {
      fDesde = fDesde + ' 00:00:00';
      fHasta = fHasta + ' 23:59:59';
    }
    return { desde: fDesde, hasta: fHasta };
  }

  filtrar() {
    if (isFalsy(this.propietarioSeleccionado)) {
      this.snackBar.showError('Seleccioná un propietario primero.', 'Atención');
      return;
    }
    if (!this.form.valid) {
      return;
    }

    const filter = new PeriodoContratoFilter();

    const ajuste = this.formatearFecha(this.form.controls["FechaAjusteDesde"].value, this.form.controls["FechaAjusteHasta"].value);
    const vencimiento = this.formatearFecha(this.form.controls["FechaVencimientoDesde"].value, this.form.controls["FechaVencimientoHasta"].value);
    const liquidacion = this.formatearFecha(this.form.controls["FechaLiquidacionDesde"].value, this.form.controls["FechaLiquidacionHasta"].value);
    const pago = this.formatearFecha(this.form.controls["FechaPagoDesde"].value, this.form.controls["FechaPagoHasta"].value);

    filter.fechaAjusteDesde = ajuste.desde;
    filter.fechaAjusteHasta = ajuste.hasta;
    filter.fechaVencimientoDesde = vencimiento.desde;
    filter.fechaVencimientoHasta = vencimiento.hasta;
    filter.fechaLiquidacionDesde = liquidacion.desde;
    filter.fechaLiquidacionHasta = liquidacion.hasta;
    filter.fechaPagoDesde = pago.desde;
    filter.fechaPagoHasta = pago.hasta;

    filter.periodoMesDesde = this.form.controls["PeriodoMesDesde"].value;
    filter.periodoAnioDesde = this.form.controls["PeriodoAnioDesde"].value;
    filter.periodoMesHasta = this.form.controls["PeriodoMesHasta"].value;
    filter.periodoAnioHasta = this.form.controls["PeriodoAnioHasta"].value;
    filter.esContratoActivo = this.form.controls["EsContratoActivo"].value;
    filter.idsTipoAjusteContrato = this.form.controls["TiposAjusteContrato"].value;
    filter.idsEstadoContrato = this.form.controls["EstadosContrato"].value;
    filter.idsPropietario = [this.propietarioSeleccionado!.id_Propietario];

    this.spinner.show();
    this.periodosContratoService.getPeriodosContratoByFilterListado(filter).subscribe(
      data => {
        this.spinner.hide();
        this.agruparPorContrato(data);
      },
      error => {
        this.spinner.hide();
        this.snackBar.showError(error, 'Error');
      }
    );
  }

  private agruparPorContrato(periodos: PeriodoContratoDetailDto[]) {
    const mapa = new Map<number, GrupoPropiedad>();

    for (const p of periodos) {
      const idContrato = (p as any).contrato?.id;
      const descripcionContrato = (p as any).contrato?.descripcion ?? 'Sin descripción';
      const porcentajeComision = (p as any).porcentajeComisionPropietario ?? 0;
      const importeNetoEstimado = p.importeAlquiler - (p.importeAlquiler * porcentajeComision / 100);

      if (!mapa.has(idContrato)) {
        mapa.set(idContrato, {
          idContrato,
          descripcionContrato,
          numeroContrato: (p as any).numeroContrato ?? null,
          direccionPropiedad: (p as any).direccionPropiedad ?? '',
          inquilino: (p as any).inquilino ?? '',
          fechaVencimientoContrato: (p as any).fechaVencimientoContrato,
          periodos: [],
          totalBruto: 0,
          totalNeto: 0,
          sortField: 'periodo',
          sortDirection: 'asc'
        });
      }

      const grupo = mapa.get(idContrato)!;
      grupo.periodos.push({
        periodoMes: p.periodoMes,
        periodoAnio: p.periodoAnio,
        periodo: `${p.periodoMes}/${p.periodoAnio}`,
        importeAlquiler: p.importeAlquiler,
        importeNetoEstimado,
        fechaVencimiento: (p as any).fechaVencimiento,
        fechaPago: (p as any).fechaPago,
        fechaLiquidacion: (p as any).fechaLiquidacion
      });
      grupo.totalBruto += p.importeAlquiler;
      grupo.totalNeto += importeNetoEstimado;
    }

    this.grupos = Array.from(mapa.values()).sort((a, b) => a.direccionPropiedad.localeCompare(b.direccionPropiedad));
    this.grupos.forEach(g => this.ordenarGrupo(g, 'periodo', true));

    this.totalGeneralBruto = this.grupos.reduce((acc, g) => acc + g.totalBruto, 0);
    this.totalGeneralNeto = this.grupos.reduce((acc, g) => acc + g.totalNeto, 0);
    this.data = this.grupos.length > 0;
  }
  limpiar() {
    this.form.reset({ EsContratoActivo: null, TiposAjusteContrato: [], EstadosContrato: [] });
    this.propietarioSeleccionado = null;
    this.grupos = [];
    this.totalGeneralBruto = 0;
    this.totalGeneralNeto = 0;
    this.data = false;
  }

  ordenarGrupo(grupo: GrupoPropiedad, campo: string, forzarAscendente: boolean = false) {
    if (forzarAscendente) {
      grupo.sortField = campo;
      grupo.sortDirection = 'asc';
    } else if (grupo.sortField === campo) {
      grupo.sortDirection = grupo.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      grupo.sortField = campo;
      grupo.sortDirection = 'asc';
    }

    const factor = grupo.sortDirection === 'asc' ? 1 : -1;

    grupo.periodos = [...grupo.periodos].sort((a, b) => {
      switch (campo) {
        case 'periodo':
          return factor * ((a.periodoAnio - b.periodoAnio) || (a.periodoMes - b.periodoMes));
        case 'fechaVencimiento':
          return factor * (this.fechaAMilisegundos(a.fechaVencimiento) - this.fechaAMilisegundos(b.fechaVencimiento));
        case 'fechaPago':
          return factor * (this.fechaAMilisegundos(a.fechaPago) - this.fechaAMilisegundos(b.fechaPago));
        case 'importeAlquiler':
          return factor * (a.importeAlquiler - b.importeAlquiler);
        case 'importeNeto':
          return factor * (a.importeNetoEstimado - b.importeNetoEstimado);
        case 'fechaLiquidacion':
          return factor * (this.fechaAMilisegundos(a.fechaLiquidacion) - this.fechaAMilisegundos(b.fechaLiquidacion));
        default:
          return 0;
      }
    });
  }

  private fechaAMilisegundos(fecha: any): number {
    return fecha ? new Date(fecha).getTime() : -Infinity;
  }

  trackByItems(index: number, item: any): any { return item; }
}
